import React from 'react';
import { useNavigate } from 'react-router-dom';

const CompactAnimeCard = ({ anime }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/anime/${anime.anime_id || anime.id}`);
  };

  // Get image URL
  const imageUrl = anime.photo_url || anime.image_url || anime.poster_url || anime.cover_image || '/placeholder-anime.png';
  const title = anime.title || anime.anime_title || 'Untitled';

  return (
    <div
      onClick={handleClick}
      className="group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-2xl"
    >
      {/* Anime Poster */}
      <div className="relative aspect-[2/3] overflow-hidden bg-white/5">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
          onError={(e) => {
            e.target.src = '/placeholder-anime.png';
          }}
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {/* Title Overlay on Hover */}
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <h3 className="text-sm font-semibold text-white line-clamp-2">
            {title}
          </h3>
        </div>
      </div>

      {/* Border glow effect */}
      <div className="absolute inset-0 border border-white/10 rounded-xl group-hover:border-cyan-400/40 transition-colors duration-300" />
    </div>
  );
};

export default CompactAnimeCard;
